import React, { useEffect } from 'react';
import { Alert, AlertIcon, Link } from '@chakra-ui/react';
import { useAuth } from './AuthProvider';
import { getPortalUrl } from './auth';
import LoadingPage from '../components/Loading';

const isDevelopment = process.env.NODE_ENV === 'development';
const isLocalhost = window.location.hostname.includes('localhost');

export const AuthenticatedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const portalUrl = getPortalUrl();

  useEffect(() => {
    // Login happens on the Portal; on localhost we show a message instead so devs aren't bounced away.
    if (!isDevelopment && !isAuthenticated && !loading && !isLocalhost) {
      window.location.href = portalUrl;
    }
  }, [isAuthenticated, loading, portalUrl]);

  // Local dev runs without a Portal session, mirroring enterprise-dashboards-ui.
  if (isDevelopment) {
    return <>{children}</>;
  }

  if (loading) {
    return <LoadingPage />;
  }

  if (!isAuthenticated && isLocalhost) {
    return (
      <Alert status="error" display="flex" justifyContent="center" alignItems="center">
        <AlertIcon />
        {'Unauthorized access. Please log in to access this page. '}
        <Link href={portalUrl} textDecoration="underline" color="blue" ml="8px">
          Log in here
        </Link>
      </Alert>
    );
  }

  if (!isAuthenticated) {
    return <LoadingPage />;
  }

  return <>{children}</>;
};

export default AuthenticatedRoute;
